export const services = [
  {
    id: 1,
    title: "بيع العقارات",
    description:
      "نسوّق عقارك باحترافية عبر قنوات متعددة ونصلك بالمشتري المناسب بأفضل سعر.",
    icon: "sale",
    features: ["تقييم مجاني", "تصوير احترافي", "تسويق رقمي", "تفاوض نيابة عنك"],
  },
  {
    id: 2,
    title: "شراء العقارات",
    description:
      "نرافقك من البحث حتى التسليم — فلترة، معاينات، فحص قانوني، وإتمام الصفقة.",
    icon: "buy",
    features: ["بحث مخصص", "معاينات منظمة", "فحص قانوني", "دعم تمويل"],
  },
  {
    id: 3,
    title: "تأجير العقارات",
    description:
      "إدارة كاملة لعقارك المؤجر: تسويق، فحص مستأجرين، عقود، ومتابعة.",
    icon: "rent",
    features: ["عقود قانونية", "فحص مستأجرين", "صيانة دورية", "تحصيل إيجار"],
  },
  {
    id: 4,
    title: "إدارة الأملاك",
    description:
      "حل متكامل للملاك: صيانة، محاسبة، تقارير دورية، وتحديثات مستمرة.",
    icon: "manage",
    features: ["تقارير شهرية", "صيانة طارئة", "محاسبة", "زيارات دورية"],
  },
  {
    id: 5,
    title: "تقييم عقاري",
    description:
      "تقييم دقيق يعتمد على بيانات السوق المحلي وخبرة أكثر من 15 عاماً.",
    icon: "valuation",
    features: ["تقرير مفصل", "مقارنة سوق", "زيارة ميدانية", "شهادة رسمية"],
  },
  {
    id: 6,
    title: "استشارات استثمارية",
    description:
      "نساعدك في اختيار العقارات ذات العائد الأفضل وفق أهدافك الاستثمارية.",
    icon: "invest",
    features: ["تحليل ROI", "دراسة جدوى", "محفظة متنوعة", "متابعة أداء"],
  },
];
